import SwiperCore, { Navigation, Pagination} from 'swiper';
import {Swiper, SwiperSlide} from "swiper/React"
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import "../../Main.scss"
import classes from "./Carousel.module.scss";
import Image from '../Image/Image';
// <--------------------- MEDIA ------------------------------>



const Carousel = (props) => {
  SwiperCore.use([Navigation, Pagination]);
  return (

    <div className={classes.Carousel + " " + (props.customClass || "")}>

    <div className="swiper-button-prev" data-id={props.id} />
      <div className={classes.Body}>
        <Swiper
          navigation={
            {nextEl: `.swiper-button-next[data-id="${props.id}"]`,
             prevEl: `.swiper-button-prev[data-id="${props.id}"]`
            }
          }
          pagination={{clickable: true, el: `.swiper-pagination[data-id="${props.id}"]`, type: "bullets", dynamicBullets: false, }}
          slidesPerView={1}
          >
            { props.media ? 
                  props.media.map( (item,index) =>  {
                 return( <SwiperSlide key={index}>
                    <Image src={item.img} key={index} srcWebp={item.imgWebp}/>
                 
                  </SwiperSlide>
                  )
                  })
              : ""
            }
          </Swiper>
        <div className="swiper-pagination" data-id={props.id} />
      </div >
      <div className="swiper-button-next" data-id={props.id} />
 
  </div>

  )
}


export default Carousel;